/* ===== Squad Cycles smooth scroll + active link ===== */
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;
  const el = document.querySelector(a.getAttribute('href'));
  if (el) {
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});

const spy = () => {
  const links = [...document.querySelectorAll('.sc-subnav__link')];
  if (!links.length) return;
  const map = links.map(a => [a, document.querySelector(a.getAttribute('href'))]).filter(([, el]) => el);
  const y = window.scrollY + 120; // offset under header
  let current = null;
  map.forEach(([a, el]) => { if (el.offsetTop <= y) current = a; });
  links.forEach(a => a.classList.toggle('is-active', a === current));
};
window.addEventListener('scroll', spy, { passive: true });
spy();
